import request from '@utils/request'
import axios from 'axios'

import { getCookie, saveCookie } from "@utils/cookie";

export const state = {
  currentMember: getCookie('auth.currentUser'),
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentMember = newValue;
    saveCookie('auth.currentUser', newValue);
    setDefaultAuthHeaders(state);
  },
};

export const getters = {
  loggedIn(state) {
    return !!state.currentMember
  },
};

export const actions = {
  init({ state }) {
    setDefaultAuthHeaders(state)
  },

  forgetPassword({ commit, dispatch, getters }, { email } = {}) {
    return request
      .post('/password/email', {
        email
      }, {customErrorHandle: ()=>{}})
  },

  resetPassword({ commit, dispatch, getters }, { password, passwordConfirm, token } = {}) {
    return request
      .post('/password/reset', {
        password,
        passwordConfirm,
        token
      }, {customErrorHandle: ()=>{}})
  },

  setCurrentUser({ commit, dispatch, getters }, user) {
    commit('SET_CURRENT_USER', user);
  },

  logIn({ commit, dispatch, getters }, { email, password,} = {}) {
    return request
      .post('/user/login', {
        email,
        password,
      }, {customErrorHandle: ()=>{}})
      .then((response) => {
        if (!response.items.hasOwnProperty('user_name')) return { status: 'USER_NEED_RESET_PASSWORD', token: response.items.token }
        const member = response.items;
        commit('SET_CURRENT_USER', member);

        return member
      })
  },

  logOut({ commit }) {
    return request
      .get('/user/logout')
      .then((response) => {

        commit('SET_CURRENT_USER', null)

        return response
      })
  },

  register({ commit, state }, submitData) {
    return request
      .post('/user/register', submitData, {customErrorHandle: ()=>{}})
      .then((response) => {
        const member = response.items;
        // commit('SET_CURRENT_USER', member);

        return member
      })
  },

  socialLogin({ commit, dispatch, getters }, { social, accessToken, merchantAlias } = {}) {
    return request
      .post(`/user/login/facebook/callback`, { access_token: accessToken }, {customErrorHandle: ()=>{}})
      .then((response) => {
        const member = response.items;
        commit('SET_CURRENT_USER', member);

        return member
      })
  },

  socialRegister({ commit, dispatch, getters }, submitData) {
    return request
      .post(`/merchant/member/register/${submitData.social}`, submitData)
      .then((response) => {
        const member = response.items;
        commit('SET_CURRENT_USER', member);

        return member
      })
  },

  activeUser({ commit, dispatch, getters }, token) {
    return request.get(`/user/activate/${token}`, {customErrorHandle: ()=>{}})
  },

  storeUser({ commit, dispatch, getters }, submitData) {
    return request.post(`/user/edit`, submitData, {customErrorHandle: ()=>{}})
      .then((response) => {
        const member = response.items;

        commit('SET_CURRENT_USER', {
          ...state.currentMember,
          ...member
        });

        return response
      })
  },

  fetchUser({ commit, dispatch, getters }) {
    return request.get(`/user`, {customErrorHandle: ()=>{}})
      .then((response) => {
        const member = response.items;

        commit('SET_CURRENT_USER', {
          ...state.currentMember,
          ...member
        });

        return response
      })
  },
};

// ===
// Private helpers
// ===

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentMember
    ? `Bearer ${state.currentMember.token}`
    : ''
}

